const UPDATES_LOG = [
    {
        version: "v1.2.1",
        title: "Project Stabilization & Routing Fix",
        date: "2026-05-03",
        changes: [
            {
                label: "Routing & Architecture",
                desc: [
                    "Resolved GitHub Pages 404 redirect loop by implementing a custom 404-to-index handoff script.",
                    "Configured React Router with 'basename' to ensure correct path parsing within the /rbxscript-scanner/ subdirectory.",
                    "Converted the static 'System Failure' error page into a modular React NotFound component with inline CSS-in-JS styling.",
                    "Initialized RBX-SCANNER with React 18 and modular CSS integration.",
                    "Established the signature-based scanning engine and primary UI grid.",
                    "Defined the 'Safe/Threat' neon color palette and dark-mode variables."
                ]
            },
        ]
    },
    {
        version: "v1.2.0",
        title: "Architecture & Personalization Update",
        date: "2026-05-02",
        changes: [
            {
                label: "Scanner detections patch @ Kyri",
                desc: [
                    "Implemented more detections for the scanner with the help of Kyri.",
                ],
                links: [
                    { text: "Github @ Kyri", url: "https://github.com/Justanewplayer19" },
                ]
            },
            {
                label: "New website layout",
                desc: [
                    "Implemented MainLayout wrapper with Navbar visibility control.",
                    "Created page /home",
                    "Created page /scanner",
                    "Created page /updates",
                    "Moved scanner form home page to /scanner",
                ]
            },
            {
                label: "Router Architecture",
                desc: [
                    "Implemented BrowserRouter with dynamic basename support for subdirectory hosting.",
                ]
            },
            {
                label: "State Persistence",
                desc: [
                    "Fixed NavLink re-rendering issues where the active indicator would disappear on manual refresh.",
                ]
            },
            {
                label: "Code Refactoring",
                desc: [
                    "Migrated to Modular Architecture: Separated logic into /components and /status folders.",
                    "Optimized App.js by destructuring styles and utilizing React Router Outlets.",
                    "Refactored updates to use a scalable array-map logic for multi-line descriptions."
                ]
            },
            {
                label: "User Interface Redesign",
                desc: [
                    "Fixed minor styling issues.",
                    "Overhauled page designs '/home', '/scanner', and '/updates'.",
                    "Added backdrop-filter: blur(15px).",
                    "Implemented high-precision box-shadow arrays.",
                    "Optimized SVG icon rendering for high-DPI displays.",
                ]
            },
            {
                label: "Syntax Debug",
                desc: [
                    "Fixed Unexpected Token errors caused by invalid property conditionals.",
                ]
            },
            {
                label: "Casing Sync",
                desc: [
                    "Standardized URL slug casing to match react-router matching algorithms.",
                ]
            },
            {
                label: "Security & Logic Patches",
                desc: [
                    "Enhanced detection engine for IP Trackers, Discord Webhooks, and RCE signatures.",
                    "Resolved :global CSS scope conflicts and fixed 'Unexpected Token' syntax errors."
                ]
            }
        ]
    },
    {
        version: "v1.0.0",
        title: "Project Genesis",
        date: "2026-05-01",
        changes: [
            {
                label: "Core Foundation",
                desc: [
                    "Initialized RBX-SCANNER with React 18 and modular CSS integration.",
                    "Established the signature-based scanning engine and primary UI grid.",
                    "Defined the 'Safe/Threat' neon color palette and dark-mode variables."
                ]
            }
        ]
    }
];

export default UPDATES_LOG;